import {
  type ListPropertiesParams,
  type PaginatedResponse,
  type Property,
} from '@/api/istaff/property';
import { makeRequestActionCreator } from '@/utils';
import { propertySearchSlice } from './slice';

const createRequestAction = makeRequestActionCreator(propertySearchSlice.name);

export const searchProperties = createRequestAction<
  ListPropertiesParams,
  PaginatedResponse<Property>
>('searchProperties');

export const {
  setResults,
  setLoading,
  setError,
  setSearchContext,
  setGroupFilters,
  resetGroupFilters,
} = propertySearchSlice.actions;
